<template>
  <div class="reproductor-fecha">
    <!-- Texto o fecha -->

    <!-- Reproductor con icono y puntitos -->
    <div class="reproductor-con-icono">
      <img
        src="@/assets/estrella.avif"
        alt="Decoración puntitos"
        class="puntitos"
      />

      <button @click="togglePlay" class="icono-play">
        <img
          src="@/assets/flecha.png"
          alt="Play/Pause"
          class="flecha-play"
        />
      </button>
    </div>

    <audio
      ref="audio"
      :src="songSource"
      preload="auto"
      autoplay
      @ended="resetPlayer"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      songSource: require('@/assets/musicafondo.mp3'),
      isPlaying: false
    };
  },
  mounted() {
    const audio = this.$refs.audio;
    audio.play().then(() => {
      this.isPlaying = true;
    }).catch(() => {
      this.isPlaying = false;
    });
  },
  methods: {
    togglePlay() {
      const audio = this.$refs.audio;
      if (this.isPlaying) {
        audio.pause();
      } else {
        audio.play();
      }
      this.isPlaying = !this.isPlaying;
    },
    resetPlayer() {
      this.isPlaying = false;
    }
  }
};
</script>

<style scoped>
.reproductor-fecha {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
  background:transparent;
}

.fecha-texto {
  font-family: 'padres';
  font-size: 14px;
  color: #5a5a5a;
  margin-bottom: 8px;
  text-align: center;
  letter-spacing: 0.5px;
}

.reproductor-con-icono {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.puntitos {
  height: 24px;
  width: auto;
}

.icono-play {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
}

.flecha-play {
  width: 62px;
  height: auto;
}
</style>
